import { Card, Grid, IconButton, Stack, TextField, Tooltip, CircularProgress } from "@mui/material";
import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EastIcon from '@mui/icons-material/East';

class Search extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isFocused: false
        };
        this.searchInputRef = React.createRef();
    }

    componentDidMount() {
        this.focusSearchInput();
    }

    componentDidUpdate(previousProps) {
        if (this.props.autoFocus && !previousProps.autoFocus) {
            this.focusSearchInput();
        }
    }

    focusSearchInput = () => {
        if (this.props.autoFocus) {
            this.searchInputRef.current?.focus();
            this.props.onAutoFocus?.();
        }
    }

    handleFocus = () => {
        this.setState({ isFocused: true });
        this.props?.setFocus?.(true);
    }

    // handleBlur = () => {
    //     console.log("Search input blurred");
    //     this.setState({ isFocused: false });
    //     this.props?.setFocus?.(false);
    // }

    miniSearchBar = () => {
        return (
            <Grid item xs={12} md={8} lg={6} xl={4}>
                <TextField
                    id="search-input-mini"
                    variant="outlined"
                    size='small'
                    label="Ask dMonk about your files"
                    placeholder="Search"
                    InputProps={{
                        sx: { borderRadius: 10 },
                        endAdornment: (
                            <>
                                {(this.props.loading) ?
                                    <CircularProgress size={20} /> : 
                                    <EastIcon fontSize="small" sx={{ color: 'lightgray' }} />
                                }
                            </>
                        )
                    }}
                    InputLabelProps={{
                        sx: { ...(this.props.value ? { color: 'inherit' } : { color: 'lightgray' }) }
                    }}
                    onChange={(e) => {
                        this.props.onChange?.(e.target.value);
                    }}
                    value={this.props.value}
                    onFocus={this.handleFocus}
                    sx={{ width: '100%', mt: '16px', borderRadius: 10, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: 'lightgray', borderWidth: 1, opacity: 0.3 } } }}
                    autoComplete='off'
                    // on 'enter' key press, search
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            if  (this.props?.onSearchAI) {
                                console.log("Enter Key Pressed -> Searching AI")
                                this.props.onSearchAI();
                            }
                        }
                    }}
                />
            </Grid>
        );
    }

    render() {

        if (this.props.mini) {
            return this.miniSearchBar();
        }

        // // After 100ms, set the TextField focussed
        // setTimeout(() => {
        //     const searchInput = document.getElementById('search-input');
        //     if (searchInput) {
        //         searchInput.focus();
        //     }
        // }, 10);


        return (
            <Grid container spacing={2} alignItems="center" sx={{ justifyContent: 'space-around' }}>
                <Grid item xs={12} md={10} lg={8} xl={6}>
                    <Stack direction="row" spacing={0} alignItems="center">
                        <TextField
                            size="small"
                            id="search-input"
                            inputRef={this.searchInputRef}
                            variant="outlined"
                            label="Ask dMonk about your files"
                            placeholder="Search"
                            InputProps={{
                                sx: { borderRadius: 10 },
                                endAdornment: (
                                    <>
                                        {(this.props.loading) ?
                                            <CircularProgress size={20} /> : 
                                            <EastIcon color="primary" fontSize="small" sx={{ opacity: 0.5 }} />
                                        }
                                    </>
                                    
                                )
                            }}
                            InputLabelProps={{
                                sx: { ...(this.props.value ? { color: 'inherit' } : { color: 'gray', opacity: 0.5 }) }
                            }}
                            onChange={(e) => {
                                this.props?.onChange?.(e.target.value);
                            }}
                            value={this.props.value}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                            sx={{ width: '100%', borderRadius: 10, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: 'lightgray', borderWidth: 1, opacity: 0.3 } } }}
                            autoComplete='off'
                            // on 'enter' key press, search
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    this.props?.onSearchAI?.();
                                }
                            }}
                        />

                        <IconButton aria-label="clear"
                            onClick={async () => {
                                this.props?.onClearSearchAndFilters?.();
                            }}
                        >
                            <ClearIcon />
                        </IconButton>
                        <IconButton aria-label="advanced-search"
                            onClick={async () => {
                                this.props?.onToggleAdvancedSearch?.();
                            }}
                        >
                            {(this.props?.advanced_search) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Stack>
                </Grid>
            </Grid>
        );
    }
}

export default Search;
